import { CONTEXT_KEYS } from './routeFilters';

const STORAGE_KEY = 'columnWidthsPreferences';

export function getColumnWidthsCacheKey(url, searchParams) {
  let key = url.replace(/\/$/, '') || '/';
  for (const contextKey of CONTEXT_KEYS) {
    const value = searchParams.get(contextKey);
    if (value) {
      key += `|${contextKey}=${value}`;
    }
  }
  return key;
}

export function getColumnWidths(cacheKey) {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const preferences = JSON.parse(stored);
      return preferences[cacheKey] || {};
    }
  } catch (e) {
    console.error('Erreur lecture préférences colonnes:', e);
  }
  return {};
}

export function saveColumnWidth(cacheKey, columnField, width) {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    const preferences = stored ? JSON.parse(stored) : {};

    if (!preferences[cacheKey]) {
      preferences[cacheKey] = {};
    }

    preferences[cacheKey][columnField] = width;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences));
  } catch (e) {
    console.error('Erreur sauvegarde préférence colonne:', e);
  }
}

export function resetColumnWidths(cacheKey) {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const preferences = JSON.parse(stored);
      delete preferences[cacheKey];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences));
    }
  } catch (e) {
    console.error('Erreur réinitialisation préférences colonnes:', e);
  }
}

export function resetAllColumnWidths() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    console.error('Erreur réinitialisation toutes préférences colonnes:', e);
  }
}
